// UQ-ja-JP
module.exports = {
  "forTest": "test for UQ-ja-JP",
  "text_styling_book_header_title": "STYLING BOOK",
  "text_styling_book_official_styling": "公式スタイリング",
  "text_styling_book_stylehint": "StyleHint",
  "text_sort": "並べ替え",
  "text_filter": "絞り込み",
  "text_styling_book_search_results_number": "{total} 件",
  "text_active_filters": "適用済みフィルター",
  "text_styling_book_clear_all_filters": "すべての条件を解除",
  "text_styling_book_search_by_feature": "特集から探す",
  "text_styling_book_search_by_category": "商品カテゴリから探す",
  "text_styling_book_staff_customer_filter_all": "すべて",
  "text_styling_book_search_by_coordinate": "コーディネートから探す",
  "text_styling_book_staff_customer_filter_title": "スタッフ / お客様",
  "text_styling_book_search_by_height": "身長から探す",
  "text_styling_book_search_by_hashtag": "ハッシュタグから探す",
  "text_styling_book_staff_customer_filter_customer_styling": "お客様スタイリング",
  "text_styling_book_staff_customer_filter_staff_styling": "スタッフスタイリング",
  "text_apply_search_filter": "絞り込む",
  "text_styling_book_no_results": "検索結果なし",
  "text_error_title": "現在サービスは利用できません",
  "text_503_error_description-1": "エラーが発生しました。",
  "text_503_error_description-2": "しばらく時間を置いて、再度お試しください。",
  "text_503_error_instruction": "ご不明点がある場合は下記よりお問い合わせください。",
  "text_styling_book_go_to_top": "ユニクロトップへ",
  "text_contactus": "お客様窓口",
  "text_wishlist": "お気に入り",
  "text_membership_info": "会員情報",
  "text_wearing_items": "着用アイテム",
  "text_color": "カラー",
  "text_size": "サイズ",
  "text_stylehint_non_listed_items_message_01": "※掲載されていない着用商品は、現在取り扱いがございません。",
  "text_styling_book_related_styling_title": "関連スタイリング",
  "text_style_styling_date_update": "更新",
  "text_styling_book_hashtag_title": "ハッシュタグ",
  "currency_format": "¥{price}",
  "text_404": "ページが見つかりませんでした",
  "text_official_styling_top_page_link": "公式スタイリングトップページへ",
  "text_stylehint_top_page_link": "StyleHintトップページへ",
  "text_breadcrumbs_top": "UNIQLO",
  "text_a11y_close": "閉じる",
  "text_log_in": "ログイン",
  "text_app_update_dialog_cancel": "キャンセル",
  "text_menu": "メニュー",
  "text_copyright": "Copyright © UNIQLO Co., Ltd. All rights reserved.",
  "text_stylehintapp": "StyleHintアプリ",
  "text_styling_book_official_styling_page_title": "公式スタイリング",
  "text_styling_book_stylehint_page_title": "StyleHint",
  "text_styling_book_sort_latest": "新着順",
  "text_styling_book_sort_popular": "人気順",
  "text_styling_book_search_by_color": "カラーから探す",
  "text_filter_clear_all_category": "すべてのカテゴリを解除",
  "text_styling_book_filter_height_over": "以上",
  "text_styling_book_filter_height_under": "以下",
  "text_show_all": "すべて表示",
  "text_error_description": "エラーが発生しました。もう一度実行するか、後ほどお試しください。",
  "text_system_error": "システムエラー",
  "text_ok": "OK",
  "text_login_required": "ログインが必要です",
  "text_login_request": "ログインページからログインを行ってください。",
  "text_error_failed_sort_product": "商品の並べ替えに失敗しました。再度、並べ替えを行ってください。",
  "text_error_failed_update_filter_criteria": "フィルター条件の変更に失敗しました。再度、フィルターを適用してください。",
  "text_meta_title_postfix": "| ユニクロ公式",
  "text_meta_title_prefix": "ユニクロ公式 |",
  "text_styling_book_meta_title_brand": "ユニクロ",
  "text_styling_book_meta_women": "レディース",
  "text_styling_book_meta_men": "メンズ",
  "text_styling_book_meta_kids": "キッズ",
  "text_styling_book_meta_baby": "ベビー",
  "text_styling_book_official_gender_meta_description": "{brand}公式オンラインストアのSTYLING BOOK。{gender}アイテムのトレンドの着こなし方を見られます。モデル着用商品はオンラインストアをチェック。",
  "text_styling_book_official_gender_meta_title": "{gender}ファッションの着こなし一覧{uqPostfix}",
  "text_styling_book_official_gender_filter_meta_title": "「{filterOptions}」の{gender}の着こなし一覧{uqPostfix}",
  "text_styling_book_official_gender_filter_meta_description": "{brand}のアイテムを活用した「{filterOptions}」の{gender}の着こなし方を紹介。トレンドアイテムの活用方法を要チェック。",
  "text_styling_book_official_detail_meta_title": "「{officialProducts}」を使った着こなし{uqPostfix}",
  "text_styling_book_official_detail_meta_description": "{brand}の「{officialProducts}」を活用した着こなしを紹介。モデルの着用のアイテムはオンラインストアをチェック。",
  "text_styling_book_stylehint_gender_meta_title": "{gender}ファッションのコーディネート一覧{uqPostfix}",
  "text_styling_book_stylehint_gender_meta_description": "{brand}公式のStyleHint。店舗スタッフ、お客様のリアルな{gender}ファッションコーディネートを「{count}」件ご紹介。",
  "text_styling_book_stylehint_filter_meta_title": "「{filterOptions}」の{gender}のコーディネート一覧 {uqPostfix}",
  "text_styling_book_stylehint_store_user_meta_title": "{userName}({storeName})のコーディネート一覧{uqPostfix}",
  "text_styling_book_stylehint_ins_user_meta_title": "{userName}のコーディネート一覧{uqPostfix}",
  "text_styling_book_stylehint_customer_user_meta_title": "{userName}({height})のコーディネート一覧{uqPostfix}",
  "text_styling_book_stylehint_detail_meta_title": "「{stylehintProducts}」の着用コーディネート{uqPostfix}",
  "text_styling_book_stylehint_store_user_meta_description": "{brand}({storeName})の{staffName}({height})のコーディネートを紹介。トレンドアイテムを使った店舗スタッフのリアルな着こなしは要チェック。",
  "text_styling_book_stylehint_ins_user_meta_description": "Instagramユーザー「{userName}」の{brand}アイテムを活用したコーディネートを紹介。ユーザーのリアルな着こなしは必見。",
  "text_styling_book_stylehint_customer_user_meta_description": "{brand}のアイテムを活用した{userName}({height})のコーディネートを紹介。気になる着用アイテムはオンラインストアをチェック。",
  "text_styling_book_stylehint_detail_meta_description": "{brand}の「{stylehintProducts}」を活用したコーディネートを紹介。店舗スタッフ、お客様のリアルなコーデは要チェック。",
  "text_styling_book_stylehint_filter_meta_description": "{brand}のアイテムを活用した「{filterOptions}」の{gender}のコーディネートを「{searchCount}」件紹介。気になる新着、トレンドアイテムはオンラインストアをチェック。",
  "text_styling_book_stylehint_styling_id_alt_tag": "{brand}スタイリングブックコーディネート Style ID: <{styleId}>",
  "text_styling_book_official_styling_id_alt_tag": "{brand}スタイリングブック 着こなし Style ID: <{styleId}>",
  "text_styling_book_official_detail_id_alt_tag": "「{officialProducts}」を使った着こなし",
  "text_styling_book_stylehint_detail_id_alt_tag": "「{stylehintProducts}」を使ったコーディネート",
  "text_styling_book_product_id_alt_tag": "{productName} {gender}",
  "text_styling_book_stylehint_user_id_alt_tag": "{userName}",
  "text_styling_book_stylehint_hashtag_alt_tag": "「{hashtag}」の{gender}のコーディネート一覧",
  "text_styling_book_stylehint_feature_alt_tag": "「{feature}」の{gender}の着こなし一覧",
  "text_style_model_height": "cm",
  "text_503_error_description": "エラーが発生しました。時間をおいて再度アクセスしてください。",
  "text_styling_book_meta_official_styling": "着こなし",
  "text_styling_book_meta_stylehint": "コーディネート",
  "text_limited_offer_until_date": "{date}まで{flagName}",
  "text_online_store_exclusive_limited_offer_until_date": "{date}まで{flagName}",
  "text_app_membership_exclusive_limited_offer_until": "{date}まで{flagName}",
  "text_csoon_early": "{month}上旬販売予定",
  "text_csoon_mid": "{month}中旬販売予定",
  "text_csoon_late": "{month}下旬販売予定",
  "text_men": "MEN",
  "text_women": "WOMEN",
  "text_kids": "KIDS",
  "text_baby": "BABY",
  "text_unisex": "男女兼用",
  "text_app_membership_exclusive_limited_offer": "アプリ会員特別価格",
  "text_styling_book_gender_menu_kids_and_baby": "Kids & Baby",
  "text_styling_book_meta_kids_and_baby": "KIDS・BABY",
  "text_a11y_favorites_add": "お気に入りに追加する",
  "text_close": "閉じる",
  "text_error_wishlist_max": "お気に入りには999点以上の商品を登録することはできません",
  "text_size_multiplication_sign": "✕",
  "text_no_image": "画像なし",
  "text_wearing_size_code01": "着用サイズ: {size_code}",
  "text_locale_hk_zh": "",
  "text_locale_en": "English",
  "text_locale_fr": "",
  "text_locale_th": "",
  "text_locale_id": "",
  "text_locale_vi": "",
  "text_locale_de": "",
  "text_locale_es": "",
  "text_locale_it": "",
  "text_locale_nl": "",
  "text_product_unavailable": "この商品は現在取り扱いしていません。",
  "text_product_display_markdown": "",
  "text_color_white": "White",
  "text_color_gray": "Gray",
  "text_color_black": "Black",
  "text_color_pink": "Pink",
  "text_color_red": "Red",
  "text_color_orange": "Orange",
  "text_color_beige": "Beige",
  "text_color_brown": "Brown",
  "text_color_yellow": "Yellow",
  "text_color_green": "Green",
  "text_color_blue": "Blue",
  "text_color_purple": "Purple",
  "text_promotion": "プロモーション",
  "text_styling_promotion_hashtag": "プロモーション",
  "text_coming_soon": "近日販売予定商品",
  "text_markdown": "値下げ",
  "text_multibuy_markdown": "まとめ買い、値下げ",
  "text_multibuy_limited_offer_until_date": "まとめ買い、{date}まで期間限定価格",
  "text_app_membership_exclusive_multi_buy_until": "{date}までアプリ会員限定まとめ買い",
  "text_app_membership_exclusive_multi_buy": "アプリ会員限定まとめ買い",
  "text_app_membership_exclusive_limitedoffers_until": "{date}までアプリ会員限定価格",
  "text_item_preorder_color_size_only": "一部先行予約商品",
  "text_item_resale_color_size_only": "一部再販商品"
}; // generated at Wed Jun 11 2025 09:41:41 GMT+0800 (Hong Kong Standard Time)